import { SText } from '@setvi/shared/components';
import { LabelValueFieldCard } from './styled';
import { ILabelValueField } from '../../../../types';
import {
  BaseLabelFieldCard,
  BaseLabelValueFieldRow,
  BaseLabelValueFieldCard
} from '../../../../styled';

interface OriginalLabelValueFieldProps {
  field: ILabelValueField;
}

export const OriginalLabelValueField = ({
  field
}: OriginalLabelValueFieldProps) => (
  <LabelValueFieldCard>
    {field.data.map(({ value, label }, index) => (
      <BaseLabelValueFieldRow key={`${label}-${index + 1}`}>
        <BaseLabelFieldCard>
          <SText
            title={label}
            weight="normal"
            size="sm"
            noLineClamp
            style={{ wordBreak: 'break-word' }}
          />
        </BaseLabelFieldCard>

        <BaseLabelValueFieldCard>
          <SText
            noLineClamp
            title={value}
            weight="semibold"
            size="sm"
            style={{ wordBreak: 'break-word' }}
          />
        </BaseLabelValueFieldCard>
      </BaseLabelValueFieldRow>
    ))}
  </LabelValueFieldCard>
);
